import type { FaireProductEntity } from "../../entity_types/product";

export const p_dqr8zyxt2k: FaireProductEntity = {
  token: "p_dqr8zyxt2k",
  type: "product",
  name: "White & Lavender Pillow 18x18in",
  brandToken: "b_b067eaumjh",
  brandName: "Happy French Gang",
  imageUrl:
    "https://cdn.faire.com/fastly/da783b363fa295edcc54988219efaf940dc0199cc4adcb8071dc44b3ceaef98e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae189f561aeffb290578e45c0a5bb5a69d22be3583a9281bfcf9cfdd8756b05e.png",
    "https://cdn.faire.com/fastly/9c8ab2e6ed7f137b85bca2765970be80d6217a4a874aed87c8f8d8d2f461cb4a.jpeg",
    "https://cdn.faire.com/fastly/0d01b1d06616f4b014f1d05d96ac359b89eae989c6de6fbe41f662ce07d4f758.jpeg",
    "https://cdn.faire.com/fastly/649b6467dec1bebede1e391de77007a8160bbedf3534c95812865eff6a536b2e.jpeg",
    "https://cdn.faire.com/fastly/5448b9041731ed0a974fb83eece5542e09f7a9679f743909466691797609884d.jpeg",
    "https://cdn.faire.com/fastly/69cab2333aad2814a16104b45e3db0c2c2f59183caa88f7d4ea6c29d43b6c1e6.png",
  ],
  priceDollars: 70,
  description:
    "This pillow is Reversible. Himalayan on one side and lavender on the other. Made from homespun, handwoven 100% super soft heavy cotton, natural dyes only and hand-stitched. We stick with our values focusing on color and texture with a sustainable product. \n\nInsert with feather and down.\n\nProcess: Somnath is the artisan from West Bengal who hand spun and weave this cotton fabric. This pillow is dyed, cut, sewn and hand-stitched in Rajasthan where we met a happy cooperative during our last trip to India. The manager started this cooperative 4 years ago to provide jobs to the women around so they could send their kids at school.\n\nCare: To maintain its beauty, cold hand wash separately. Refresh in a bath of gentle soap or gently use your hands to slightly rub. Use a natural detergent that does not contain citrus or other acidic oil scents. Machine dry on low or hang dry out of direct sunlight.\n\nThis product has been dyed or block-printed using ancient techniques. Colors may gradually change over time.\n\n\n",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:00.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
